import { defineMessages } from "react-intl";

export default defineMessages({
    messageNotInitialized: {
        id: "components.project.projectMembers.messageNotInitialized",
        defaultMessage: "Project is not initialized. Initialize it using details form first.",
    },
});
